import commonService from "./common.service";

const BASE = "/p2p/transactions";

const p2pTransactionService = {
  list: (filters = {}) => commonService.get(BASE, filters),
  create: (payload) => commonService.post(BASE, payload),
  detail: (id) => commonService.get(`${BASE}/${id}`),
  update: (id, payload) => commonService.put(`${BASE}/${id}`, payload),
  changeStatus: (id, payload) => commonService.post(`${BASE}/${id}/status`, payload),
  startApprovalFlow: (id, payload = {}) =>
    commonService.post(`${BASE}/${id}/start-approval`, payload),
  addComment: (id, payload) => commonService.post(`${BASE}/${id}/comments`, payload),
  addAttachment: (id, payload) => commonService.post(`${BASE}/${id}/attachments`, payload),
  addDocument: (id, payload) => commonService.post(`${BASE}/${id}/documents`, payload),
  timeline: (id) => commonService.get(`${BASE}/${id}/timeline`),
};

export default p2pTransactionService;
